import { AxiosResponse } from "axios";
import { api } from "../util/api";
export function getAccessToken(
  body?: any
): Promise<AxiosResponse<{ access_token: string }>> {
  return api.post("/line/accesstoken", body);
}

export function getLineClientId() {
  return api.get("/line/config");
}
export function sendMessage(body: any) {
  return api.post("/line/message", body);
}
